// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.video-container {
  width: 100%;
  height: 75vh;
  min-height: 420px;
  max-height: 760px;
  border-radius: 12px;
  overflow: hidden;
  background: #000;
}

/* Large desktops */
@media (min-width: 1400px) {
  .video-container {
    height: 78vh;
    max-height: 780px;
  }
}
/* Normal laptop screens */
@media (max-width: 1399px) {
  .video-container {
    height: 70vh;
    max-height: 680px;
  }
}
/* Smaller laptops / tablets */
@media (max-width: 1199px) {
  .video-container {
    height: 60vh;
    min-height: 380px;
  }
}
/* Tablets and mobile */
@media (max-width: 991px) {
  .video-container {
    height: 480px;
    width: 100%;
    margin-top: 20px;
  }
}
/* Small mobile */
@media (max-width: 575px) {
  .video-container {
    height: 420px;
    border-radius: 8px;
  }
}
/* Fullscreen mode */
.video-container--full {
  position: fixed;
  inset: 0;
  width: 100vw;
  height: 100vh;
  max-height: none;
  border-radius: 0;
  z-index: 9999;
}

.prescription-floating-call {
  position: fixed;
  top: 96px;
  right: 24px;
  width: 360px;
  height: calc(100vh - 120px);
  z-index: 99999;
  background: #000;
  border-radius: 12px;
  overflow: hidden;
}

.prescription-floating-call .video-container {
  width: 100%;
  height: 100%;
}

.prescription-floating-call .video-container > div {
  width: 100%;
  height: 100%;
}`, "",{"version":3,"sources":["webpack://./src/pages/Appointments/video.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;AACF;;AAEA,mBAAA;AACA;EACE;IACE,YAAA;IACA,iBAAA;EACF;AACF;AAEA,0BAAA;AACA;EACE;IACE,YAAA;IACA,iBAAA;EAAF;AACF;AAGA,8BAAA;AACA;EACE;IACE,YAAA;IACA,iBAAA;EADF;AACF;AAIA,uBAAA;AACA;EACE;IACE,aAAA;IACA,WAAA;IACA,gBAAA;EAFF;AACF;AAKA,iBAAA;AACA;EACE;IACE,aAAA;IACA,kBAAA;EAHF;AACF;AAMA,oBAAA;AACA;EACE,eAAA;EACA,QAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;AAJF;;AAOA;EACE,eAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,2BAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AAJF;;AAOA;EACE,WAAA;EACA,YAAA;AAJF;;AAOA;EACE,WAAA;EACA,YAAA;AAJF","sourcesContent":[".video-container {\n  width: 100%;\n  height: 75vh;\n  min-height: 420px;\n  max-height: 760px;\n  border-radius: 12px;\n  overflow: hidden;\n  background: #000;\n}\n\n/* Large desktops */\n@media (min-width: 1400px) {\n  .video-container {\n    height: 78vh;\n    max-height: 780px;\n  }\n}\n\n/* Normal laptop screens */\n@media (max-width: 1399px) {\n  .video-container {\n    height: 70vh;\n    max-height: 680px;\n  }\n}\n\n/* Smaller laptops / tablets */\n@media (max-width: 1199px) {\n  .video-container {\n    height: 60vh;\n    min-height: 380px;\n  }\n}\n\n/* Tablets and mobile */\n@media (max-width: 991px) {\n  .video-container {\n    height: 480px;\n    width: 100%;\n    margin-top: 20px;\n  }\n}\n\n/* Small mobile */\n@media (max-width: 575px) {\n  .video-container {\n    height: 420px;\n    border-radius: 8px;\n  }\n}\n\n/* Fullscreen mode */\n.video-container--full {\n  position: fixed;\n  inset: 0;\n  width: 100vw;\n  height: 100vh;\n  max-height: none;\n  border-radius: 0;\n  z-index: 9999;\n}\n\n.prescription-floating-call {\n  position: fixed;\n  top: 96px;\n  right: 24px;\n  width: 360px;\n  height: calc(100vh - 120px);\n  z-index: 99999;\n  background: #000;\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n.prescription-floating-call .video-container {\n  width: 100%;\n  height: 100%;\n}\n\n.prescription-floating-call .video-container > div {\n  width: 100%;\n  height: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
